(() => {
  'use strict';
  const root = document.documentElement;
  root.classList.replace('no-js', 'js');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const currentMenu = () => document.getElementById('UniMobileMenu');
  const syncMenu = () => {
    const open = Boolean(currentMenu()?.open);
    document.querySelector('[data-menu-toggle]')?.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('uni-menu-is-open', open);
  };
  const closeMenu = (immediate = false) => { const menu = currentMenu(); if (menu && window.UniMotionPanels) window.UniMotionPanels.close(menu, { immediate }); else menu?.close(); syncMenu(); };
  document.addEventListener('click', event => {
    const menu = currentMenu();
    if (!menu) return;
    if (event.target.closest('[data-menu-toggle]')) {
      if (menu.open) closeMenu();
      else { if (window.UniMotionPanels) window.UniMotionPanels.open(menu); else menu.showModal(); syncMenu(); }
    } else if (event.target.closest('#UniMobileMenu a')) closeMenu(true);
    else if (event.target.closest('[data-menu-close]')) closeMenu();
    else if (event.target === menu) {
      const rect = menu.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeMenu();
    }
  });
  document.addEventListener('close', event => { if (event.target.id === 'UniMobileMenu') syncMenu(); }, true);
  document.addEventListener('cancel', event => { if (event.target.id === 'UniMobileMenu') { event.preventDefault(); closeMenu(); } }, true);
  window.addEventListener('pagehide', () => closeMenu(true));
  window.addEventListener('popstate', () => closeMenu(true));
  window.matchMedia('(min-width: 990px)').addEventListener('change', event => { if (event.matches) closeMenu(true); });
  document.addEventListener('shopify:section:unload', event => { if (event.target.querySelector('[data-menu-toggle]')) closeMenu(true); });
  document.addEventListener('shopify:section:load', event => { if (event.target.querySelector('[data-menu-toggle]')) syncMenu(); });
  function initMotion(scope=document) {
    if (reduced.matches || document.body.dataset.motion === 'none' || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => entries.forEach(entry => { if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);} }), {threshold:.08,rootMargin:'0px 0px -20px 0px'});
    scope.querySelectorAll('.uni-reveal:not(.is-visible)').forEach(el => { if(el.dataset.motion !== 'none' && !el.closest('[data-motion="none"]')) {el.classList.add('will-reveal');observer.observe(el);} });
  }
  document.addEventListener('uni:motionchange', () => {
    if (document.body.dataset.motion === 'none') document.querySelectorAll('.will-reveal').forEach(el => el.classList.add('is-visible'));
  });
  initMotion();
  document.addEventListener('shopify:section:load', e => initMotion(e.target));
  reduced.addEventListener('change', e => {if(e.matches)document.querySelectorAll('.will-reveal').forEach(el=>el.classList.add('is-visible'));});
})();
